export const enumsActions = {
    CONFLICT_RESOLVE_ACTION_TYPES: 'CONFLICT_RESOLVE_ACTION_TYPES',
    CONTINUOUS_INTEGRATION_TYPES: 'CONTINUOUS_INTEGRATION_TYPES',
    DUPLICATION_ACTION_TYPES: 'DUPLICATION_ACTION_TYPES',
    FILE_VERSION_CONTROL_TYPES: 'FILE_VERSION_CONTROL_TYPES',
    DEPLOY_MODE_TYPES: 'DEPLOY_MODE_TYPES',
    SET_ENUMS: 'SET_ENUMS',
    DB_TYPES: 'DB_TYPES',
    SOURCE_CONTROL_PATH_TYPES: 'SOURCE_CONTROL_PATH_TYPES'
};

const initState = {};

export const enumsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case enumsActions.SET_ENUMS:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/enumsReducer.ts